export function SAVE_ACTIVITIES(state, [activities]) {
	state.activities = activities
}

export function SAVE_ACTIVITIES_MENU(state, [activities_menu]) {
	state.activities_menu = activities_menu
}

export function SAVE_ACTIVITIES_MENU_LOADING(state, [activities_menu, loading]) {
	state.activities_menu = activities_menu
	state.loading = loading
}

export function SAVE_ACTIVITY(state, [hierarchy_order, id]) {
	state.hierarchy_order = hierarchy_order
	state.id = id
}

export function SAVE_ACTIVITY_DATA(state, [activity]) {
	state.activities = state.activities.map((act) =>
		act.hierarchy_order != activity.hierarchy_order ? act : activity
	)
}

export function SAVE_BLOCK_ACTIVITIES_MENU(state, [block_activities_menu]) {
	state.block_activities_menu = block_activities_menu
}

export function SAVE_CLEAR_ACTIVITIES(state, []) {
	;(state.activities = []),
		(state.activities_menu = []),
		(state.hierarchy_order = null),
		(state.id = null),
		(state.loading = false),
		(state.block_activities_menu = false)
}
